import * as React from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import LoadingState from '../LoadingState'

interface GuestGuardProps {
  children: React.ReactNode
}

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isInitialized } = useAuth()

  const [query] = useSearchParams()

  const redirect = query.get('redirect') ? decodeURI(query.get('redirect') as string) : null

  if (!isInitialized) {
    return <LoadingState />
  }

  if (isAuthenticated) {
    return redirect ? <Navigate to={redirect} /> : <Navigate to="/" />
  }

  return <React.Fragment>{children}</React.Fragment>
}
